import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
    wrapper: {
        transition: 'all .2s',
        display: 'block',
        color: theme.palette.primary.light,
        float: 'right',
        fontSize: '17px',
        textDecoration: 'none',
        marginTop: 10,
        paddingRight: 5,
        '& span': {
            transition: 'all .2s',
        },
        '&:hover, &:focus': {
            color: theme.palette.primary.dark,
            '& span.crossOver': {
                opacity: 0,
            },
            '& span.arrowOver': {
                opacity: 1,
                '& flos-icon > svg': {
                    stroke: theme.palette.primary.dark,
                },
            },
        },
    },
    cross: {
        top: '1px',
        opacity: 1,
        position: 'absolute',
    },
    arrow: {
        top: '-1px',
        opacity: 0,
        position: 'absolute',
        '& flos-icon > svg': {
            strokeWidth: '2px',
            stroke: theme.palette.primary.light,
        },
    },
    left: {
        float: 'left',
    },
    right: {
        float: 'left',
        position: 'relative',
        paddingLeft: 8,
    },
}));
